// import { useEffect, useMemo, useState } from 'react';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { Card, CardBody } from '@components/card/card';
// import { useTranslation } from 'react-i18next';
// import Select from 'react-select';
// import { Link, useNavigate } from 'react-router-dom';
// import useGetInvReceiveList from '@hooks/INV/InvReceive/useGetInvReceiveList';
// import useGetTransactionTypesReceiveList from '@hooks/INV/InvReceive/useGetTransactionTypesReceiveList';
// import Loading from '@components/Shared/Loader/Loading';
// import NtxTable from '@components/DataTable/NtxTable';
// import NeatixModal from '@components/Modal/NeatixModal';
// import ListPrint from '@components/Print/ListPrint';
// import { usePermissions } from '@Helper/Permisstions/usePermissions';

// // ===========================
// // Helpers: debounce + normalize
// // ===========================
// function useDebouncedValue<T>(value: T, delayMs = 250) {
//   const [debounced, setDebounced] = useState(value);

//   useEffect(() => {
//     const t = setTimeout(() => setDebounced(value), delayMs);
//     return () => clearTimeout(t);
//   }, [value, delayMs]);

//   return debounced;
// }

// const stripArabicDiacritics = (s: string) => s.replace(/[\u0610-\u061A\u064B-\u065F\u06D6-\u06ED]/g, '');

// const normalizeText = (input: any) => {
//   if (input == null) return '';
//   const s = String(input);

//   const ar = stripArabicDiacritics(s)
//     .replace(/[أإآ]/g, 'ا')
//     .replace(/ة/g, 'ه')
//     .replace(/ى/g, 'ي')
//     .replace(/ؤ/g, 'و')
//     .replace(/ئ/g, 'ي')
//     .replace(/ـ/g, '');

//   return ar.toLowerCase().normalize('NFKD').replace(/\s+/g, ' ').trim();
// };

// const toISODate = (d: any) => {
//   try {
//     if (!d) return '';
//     const s = String(d);
//     return s.includes('T') ? s.split('T')[0] : s;
//   } catch {
//     return '';
//   }
// };

// const buildHaystack = (item: any, t: any) => {
//   const postedText = item?.postedFlag ? `${t('Posted')} posted true نعم` : `${t('NotPosted')} not posted false لا`;

//   const parts = [
//     // أهم حقول المستخدم
//     item?.code,
//     item?.referenceCode,
//     item?.transactionTypeName,
//     item?.referenceType,
//     toISODate(item?.transactionDate),
//     item?.transactionAmount,

//     item?.description,
//     item?.note,
//     item?.address,

//     // IDs
//     item?.id,
//     item?.referenceId,
//     item?.branchId,
//     item?.inventoryId,
//     item?.customerId,
//     item?.supplierId,
//     item?.personId,

//     // flags
//     item?.inventoryFlag,
//     item?.isAutomatic,
//     item?.hasManualCost,

//     postedText
//   ];

//   return normalizeText(parts.filter(v => v !== undefined && v !== null && v !== '').join(' | '));
// };

// const Index = () => {
//   const { HasPermission } = usePermissions();
//   const [transItem, setTransItem] = useState<any>();
//   const [show, setShow] = useState(false);
//   const [search, setSearch] = useState('');
//   const [transTypeId, setTransTypeId] = useState<any>();

//   const debouncedSearch = useDebouncedValue(search, 250);

//   const { t } = useTranslation();
//   const Navigate = useNavigate();

//   const { InvReceiveList, loading, error } = useGetInvReceiveList();
//   const { OptionsTransactionTypes, loading: loading2 } = useGetTransactionTypesReceiveList();

//   // ===========================
//   // Filter + Sort (memoized)
//   // ===========================
//   const filteredList = useMemo(() => {
//     const list = InvReceiveList ?? [];
//     const q = normalizeText(debouncedSearch);
//     const tokens = q ? q.split(' ').filter(Boolean) : [];

//     const out = list.filter((item: any) => {
//       const transTypeOk = transTypeId ? item.transactionTypeId === transTypeId : true;
//       if (!transTypeOk) return false;

//       if (tokens.length === 0) return true;

//       const hay = buildHaystack(item, t);
//       return tokens.every(tok => hay.includes(tok));
//     });

//     out.sort((a: any, b: any) => {
//       const da = new Date(a?.transactionDate ?? 0).getTime();
//       const db = new Date(b?.transactionDate ?? 0).getTime();
//       return db - da; // الأحدث أولاً
//     });

//     return out;
//   }, [InvReceiveList, debouncedSearch, transTypeId, t]);

//   const columns = [
//     { title: t('TransType'), key: 'type' },
//     { title: t('Date'), key: 'date' },
//     { title: t('Number'), key: 'num' },
//     { title: t('ReferenceNumber'), key: 'ref' },
//     { title: t('Status'), key: 'status' },
//     { title: t(''), key: 'action', className: 'text-end', sortable: false }
//   ];

//   const tableData = useMemo(() => {
//     const getTransactionBadge = (transactionType: string) => {
//       switch (transactionType) {
//         case 'مردود مشتريات':
//           return (
//             <span className='badge bg-warning p-2'>
//               <i className='fas fa-undo me-1'></i> {t('PurchaseReturn')}
//             </span>
//           );
//         case 'امر صيانة':
//           return (
//             <span className='badge bg-info p-2'>
//               <i className='fas fa-tools me-1'></i> {t('MaintenanceOrder')}
//             </span>
//           );
//         case 'صرف امر تحويل':
//           return (
//             <span className='badge bg-danger p-2'>
//               <i className='fas fa-exchange-alt me-1'></i> {t('TransferIssue')}
//             </span>
//           );
//         case 'Sales Order Issue':
//           return (
//             <span className='badge bg-primary p-2'>
//               <i className='fas fa-shopping-cart me-1'></i> {t('SalesOrder')}
//             </span>
//           );
//         case 'Miscellaneous Issue':
//           return (
//             <span className='badge bg-danger p-2'>
//               <i className='fas fa-arrow-up me-1'></i> {t('Issue')}
//             </span>
//           );
//         case 'صرف مواد خام':
//           return (
//             <span className='badge bg-dark p-2'>
//               <i className='fas fa-box-open me-1'></i> {t('RawMaterialIssue')}
//             </span>
//           );
//         case 'استلام منتج نهائي':
//           return (
//             <span className='badge bg-success p-2'>
//               <i className='fas fa-box me-1'></i> {t('FinalProductReceipt')}
//             </span>
//           );
//         case 'Move Order Receipt':
//           return (
//             <span className='badge bg-secondary p-2'>
//               <i className='fas fa-exchange-alt me-1'></i> {t('TransferReceipt')}
//             </span>
//           );
//         case 'Miscellaneous Receipt':
//           return (
//             <span className='badge bg-success p-2'>
//               <i className='fas fa-plus me-1'></i> {t('Addition')}
//             </span>
//           );
//         case 'Purchases Order':
//           return (
//             <span className='badge bg-primary p-2'>
//               <i className='fas fa-shopping-bag me-1'></i> {t('PurchaseOrder')}
//             </span>
//           );
//         case 'مردود مبيعات':
//           return (
//             <span className='badge bg-warning p-2'>
//               <i className='fas fa-reply me-1'></i> {t('SalesReturn')}
//             </span>
//           );
//         default:
//           return (
//             <span className='badge bg-secondary p-2'>
//               <i className='fas fa-question-circle me-1'></i> {t('Unknown')}
//             </span>
//           );
//       }
//     };

//     return (filteredList || []).map((item: any) => {
//       const postedFlagBadge = item.postedFlag ? (
//         <span className='badge bg-success'>
//           <i className='fas fa-check me-1'></i>
//           {t('Posted')}
//         </span>
//       ) : (
//         <span className='badge bg-danger'>
//           <i className='fas fa-times me-1'></i>
//           {t('NotPosted')}
//         </span>
//       );

//       return {
//         num: item.code,
//         date: toISODate(item?.transactionDate) || '—',
//         type: getTransactionBadge(item.transactionTypeName),
//         ref: item.referenceCode || '---------------',
//         status: postedFlagBadge,
//         action: (
//           <>
//             {HasPermission('INVViewInvReceiveDetails') && (
//               <button
//                 type='button'
//                 className='btn btn-sm btn-outline-theme me-1'
//                 onClick={() => Navigate(`${item.id}/UpdateInvReceive`)}
//               >
//                 <i className='far fa-lg fa-fw fa-edit'></i>
//               </button>
//             )}

//             <button
//               type='button'
//               className='btn btn-sm btn-outline-secondary me-1'
//               onClick={() => {
//                 setTransItem(item);
//                 setShow(true);
//               }}
//             >
//               <i className='fas fa-lg fa-fw fa-print'></i>
//             </button>

//             {HasPermission('INVEditInvReceive') && (
//               <button type='button' className='btn btn-sm btn-outline-danger me-1'>
//                 <i className='far fa-lg fa-fw fa-trash-alt'></i>
//               </button>
//             )}
//           </>
//         )
//       };
//     });
//   }, [filteredList, HasPermission, Navigate, t]);

//   const BcrumbList = [
//     { name: t('Home'), link: ':moduleHome' },
//     { name: t('InvReceive'), link: null }
//   ];

//   return (
//     <>
//       <div className='d-flex align-items-center'>
//         <Breadcrumb BreadcrumbList={BcrumbList} PageName={t('InvReceive')} />

//         <div className='ms-auto'>
//           {HasPermission('INVAddInvReceive') && (
//             <Link to='AddInvReceive' className='btn me-1 btn-theme'>
//               <i className='fa fa-plus-circle fa-fw me-1'></i>
//               {t('AddInvReceive')}
//             </Link>
//           )}
//         </div>
//       </div>

//       <Card>
//         <Loading loading={loading} error={error}>
//           <CardBody>
//             <div className='row mb-2'>
//               <div className='col-lg-6'>
//                 <div className='input-group flex-nowrap'>
//                   <span className='input-group-text fw-bold'>{t('Search')}</span>

//                   <div className='input-group'>
//                     <div className='flex-fill position-relative'>
//                       <div className='input-group border-0 '>
//                         <div className='input-group-text position-absolute top-0 bottom-0 bg-none border-0 pe-0'>
//                           <i className='fa fa-search opacity-5 text-theme'></i>
//                         </div>

//                         <input
//                           type='text'
//                           autoComplete='off'
//                           className='form-control ps-35px'
//                           value={search}
//                           // placeholder={`${t('Search')} (Code, Ref, Type, Date, Posted, Amount, IDs...)`}
//                           onChange={e => setSearch(e.target.value)}
//                           onKeyDown={e => {
//                             if (e.key === 'Escape') setSearch('');
//                           }}
//                         />

//                         {!!search && (
//                           <button
//                             type='button'
//                             className='btn btn-outline-secondary'
//                             onClick={() => setSearch('')}
//                             title={t('Clear')}
//                           >
//                             <i className='fas fa-times'></i>
//                           </button>
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className='col-lg-6'>
//                 <div className='input-group flex-nowrap'>
//                   <span className='input-group-text fw-bold'>{t('TransType')}</span>
//                   <Select
//                     classNamePrefix='react-select'
//                     className='w-100'
//                     isLoading={loading2}
//                     isSearchable
//                     isClearable
//                     options={OptionsTransactionTypes}
//                     onChange={option => setTransTypeId(option?.transTypeId)}
//                     placeholder={t('Choose')}
//                   />
//                 </div>
//               </div>
//             </div>

//             <NtxTable
//               data={tableData || []}
//               columns={columns}
//               dataPerPage={10}
//               theadClass=''
//               tableClass='table text-nowrap table-hover '
//             />
//           </CardBody>
//         </Loading>
//       </Card>

//       <NeatixModal show={show} setShow={setShow} size='sm' showHeader={false} centered bodyClassName='p-0'>
//         <Card>
//           <CardBody>
//             {transItem && (
//               <>
//                 <div className='text-theme text-center bg-theme bg-opacity-10 fs-4 fw-bold mb-3'>{transItem?.code}</div>
//                 <ListPrint ReferenceId={transItem.id} PrintTemplateTypeId='4F0C8A75-34C7-4701-A35F-D9D92C4FFFC5' />
//               </>
//             )}
//             <button
//               type='button'
//               className='btn btn-lg btn-default rounded-1 w-100 mt-3'
//               onClick={() => setShow(false)}
//             >
//               <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
//             </button>
//           </CardBody>
//         </Card>
//       </NeatixModal>
//     </>
//   );
// };

// export default Index;

import { useEffect, useState } from 'react';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card, CardFooter, CardHeader } from '@components/card/card';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import Loading from '@components/Shared/Loader/Loading';
import NeatixModal from '@components/Modal/NeatixModal';
import Select from 'react-select';

import { usePermissions } from '@Helper/Permisstions/usePermissions';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getPagedData, setEndpoint, setFilters } from '@store/DynamicSlice/dynamicTableSlice';
import { DynamicFilter } from '@Helper/DynamicFilter/DynamicFilter';
import { DynamicPagination } from '@Helper/DynamicFilter/DynamicPagination';

// ✅ نفس القديم (لو عندك هذا الهوك)
import useGetTransactionTypesReceiveList from '@hooks/INV/InvReceive/useGetTransactionTypesReceiveList';

// ✅ نفس القديم (عدّل مسار الاستيراد حسب مشروعك)
import ListPrint from '@components/Print/ListPrint';
import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermissionCache';
import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';

const TABLE_KEY = 'InvReceive_Index';

const Index = () => {
  const { t, i18n } = useTranslation();
  const { HasPermission } = usePermissions();
  const Navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { OperatingUnitOptions, loading: loadingOperatingUnitOptions } = useGetOperatingUnitWithPermission();
  const { InventoryOptions, loading: loadingInventoryOptions } = useGetInventoryWithPermission();
  // ===========================
  // DynamicTable state
  // ===========================
  const tableState = useAppSelector(state => state.dynamicTable[TABLE_KEY]);
  const data = tableState?.data ?? [];
  const loading = tableState?.loading ?? false;
  const error = tableState?.error ?? null;
  const filters = tableState?.filters ?? [];
  const [activeFiltersCount, setActiveFiltersCount] = useState(0);

  // ===========================
  // Local filters (مثل مثال السندات)
  // ===========================
  const [branchFilter, setBranchFilter] = useState<any>(null);
  const [inventoryFilter, setInventoryFilter] = useState<any>(null);
  const [transTypeFilter, setTransTypeFilter] = useState<any>(null);
  const [postedFilter, setPostedFilter] = useState<any>(null);
  const [referenceTypeFilter, setReferenceTypeFilter] = useState<any>(null);

  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [showFilters, setShowFilters] = useState(false);

  // ===========================
  // Print modal (مثل القديم)
  // ===========================
  const [showPrint, setShowPrint] = useState(false);
  const [transItem, setTransItem] = useState<any>(null);

  // ===========================
  // Options
  // ===========================
  const { OptionsTransactionTypes, loading: loadingTransTypes } = useGetTransactionTypesReceiveList();

  const postedOptions = [
    { value: true, label: t('Posted') },
    { value: false, label: t('NotPosted') }
  ];

  // ===========================
  // Init table
  // ===========================
  useEffect(() => {
    dispatch(setEndpoint({ tableKey: TABLE_KEY, endpoint: 'InvReceive/GeList_Paged' }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  }, [dispatch]);

  useEffect(() => {
    setActiveFiltersCount(filters.length);
  }, [filters]);

  // ===========================
  // Helpers
  // ===========================
  const generateFilterId = () => `filter-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

  const getOptionValue = (opt: any) => opt?.value ?? opt?.id ?? opt?.transTypeId ?? opt?.branchId ?? opt?.inventoryId;

  const safeDate = (dt: string) => (dt ? dt.split('T')[0] : '—');

  const getPostedFlagBadge = (flag: boolean) =>
    flag ? (
      <span className='badge bg-success'>
        <i className='fas fa-check me-1'></i>
        {t('Posted')}
      </span>
    ) : (
      <span className='badge bg-danger'>
        <i className='fas fa-times me-1'></i>
        {t('NotPosted')}
      </span>
    );

  // ✅ نفس روح القديم (Badges للنوع)
  const getTransactionBadge = (transactionType: string) => {
    const type = (transactionType || '').trim();

    switch (type) {
      case 'مردود مشتريات':
        return (
          <span className='badge bg-warning '>
            <i className='fas fa-undo me-1'></i> {t('PurchaseReturn')}
          </span>
        );
      case 'امر صيانة':
        return (
          <span className='badge bg-info '>
            <i className='fas fa-tools me-1'></i> {t('MaintenanceOrder')}
          </span>
        );
      case 'صرف امر تحويل':
        return (
          <span className='badge bg-danger '>
            <i className='fas fa-exchange-alt me-1'></i> {t('TransferIssue')}
          </span>
        );
      case 'Sales Order Issue':
        return (
          <span className='badge bg-primary '>
            <i className='fas fa-shopping-cart me-1'></i> {t('SalesOrder')}
          </span>
        );
      case 'Miscellaneous Issue':
        return (
          <span className='badge bg-danger '>
            <i className='fas fa-arrow-up me-1'></i> {t('Issue')}
          </span>
        );
      case 'صرف مواد خام':
        return (
          <span className='badge bg-dark '>
            <i className='fas fa-box-open me-1'></i> {t('RawMaterialIssue')}
          </span>
        );
      case 'استلام منتج نهائي':
        return (
          <span className='badge bg-success '>
            <i className='fas fa-box me-1'></i> {t('FinalProductReceipt')}
          </span>
        );
      case 'Move Order Receipt':
        return (
          <span className='badge bg-secondary '>
            <i className='fas fa-exchange-alt me-1'></i> {t('TransferReceipt')}
          </span>
        );
      case 'Miscellaneous Receipt':
        return (
          <span className='badge bg-success '>
            <i className='fas fa-plus me-1'></i> {t('Addition')}
          </span>
        );
      case 'Purchases Order':
        return (
          <span className='badge bg-primary '>
            <i className='fas fa-shopping-bag me-1'></i> {t('PurchaseOrder')}
          </span>
        );
      case 'مردود مبيعات':
        return (
          <span className='badge bg-warning '>
            <i className='fas fa-reply me-1'></i> {t('SalesReturn')}
          </span>
        );
      default:
        return (
          <span className='badge bg-secondary '>
            <i className='fas fa-question-circle me-1'></i> {type || t('Unknown')}
          </span>
        );
    }
  };

  // ===========================
  // Apply/Clear filters (مثل مثال السندات)
  // ===========================
  const applyFilters = () => {
    const newFilters: any[] = [];

    if (branchFilter) {
      newFilters.push({
        id: generateFilterId(),
        field: 'branchId',
        operator: 0,
        value: getOptionValue(branchFilter)
      });
    }

    if (inventoryFilter) {
      newFilters.push({
        id: generateFilterId(),
        field: 'inventoryId',
        operator: 0,
        value: getOptionValue(inventoryFilter)
      });
    }

    if (transTypeFilter) {
      newFilters.push({
        id: generateFilterId(),
        field: 'transactionTypeId',
        operator: 0,
        // value: getOptionValue(transTypeFilter)
        value: transTypeFilter?.transTypeId
      });
    }

    if (postedFilter) {
      newFilters.push({
        id: generateFilterId(),
        field: 'postedFlag',
        operator: 0,
        value: postedFilter.value
      });
    }

    if (referenceTypeFilter) {
      newFilters.push({
        id: generateFilterId(),
        field: 'referenceType',
        operator: 0,
        value: referenceTypeFilter.value
      });
    }

    if (dateFrom) {
      newFilters.push({
        id: generateFilterId(),
        field: 'transactionDate',
        operator: 3, // >=
        value: dateFrom
      });
    }

    if (dateTo) {
      newFilters.push({
        id: generateFilterId(),
        field: 'transactionDate',
        operator: 5, // <=
        value: dateTo
      });
    }

    dispatch(setFilters({ tableKey: TABLE_KEY, filters: newFilters }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  };

  const clearFilters = () => {
    setBranchFilter(null);
    setInventoryFilter(null);
    setTransTypeFilter(null);
    setPostedFilter(null);
    setReferenceTypeFilter(null);
    setDateFrom('');
    setDateTo('');

    dispatch(setFilters({ tableKey: TABLE_KEY, filters: [] }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  };

  // ===========================
  // DynamicFilter fields (السلايدر)
  // ===========================
  const fields: any = [
    { name: 'code', label: t('Number'), type: 'string' },
    { name: 'transactionDate', label: t('Date'), type: 'date' },
    {
      name: 'postedFlag',
      label: t('PostingStatus'),
      type: 'options',
      options: postedOptions
    },
    // {
    //   name: 'referenceType',
    //   label: t('ReferenceType'),
    //   type: 'options',
    //   options: referenceTypeOptions
    // },
    { name: 'referenceCode', label: t('ReferenceNumber'), type: 'string' },

    {
      name: 'transactionTypeId',
      label: t('TransType'),
      type: 'options',
      // لو OptionsTransactionTypes جاهزة كـ {label,value} ممتاز، لو لا فمش مشكلة لأن DynamicFilter غالباً يعتمد value/label
      options: OptionsTransactionTypes || []
    },

    { name: 'branchId', label: t('OperationUnit'), type: 'options', options: OperatingUnitOptions },
    { name: 'inventoryId', label: t('Inventory'), type: 'options', options: InventoryOptions }
  ];

  const breadcrumbList = [
    { name: t('Home'), link: ':moduleHome' },
    { name: t('InvReceive'), link: null }
  ];

  return (
    <>
      <div className='d-flex flex-wrap align-items-center gap-2'>
        <Breadcrumb BreadcrumbList={breadcrumbList} PageName={t('InvReceive')} />

        <div className='ms-auto'>
          {HasPermission('INVAddInvReceive') && (
            <Link to='AddInvReceive' className='btn btn-theme'>
              <i className='fa fa-plus-circle fa-fw me-1'></i>
              {t('AddInvReceive')}
            </Link>
          )}
        </div>
      </div>

      <Card className='mb-4'>
        <CardHeader>
          <div className='row g-2'>
            <div className='col-lg-4'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-building'></i>
                </span>
                <Select
                  isLoading={loadingOperatingUnitOptions}
                  value={branchFilter}
                  onChange={setBranchFilter}
                  options={OperatingUnitOptions}
                  placeholder={t('  وحدة تشغيـل')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                  }}
                />
              </div>
            </div>

            {/* ✅ المخزن */}
            <div className='col-lg-4'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-warehouse'></i>
                </span>
                <Select
                  isLoading={loadingInventoryOptions}
                  value={inventoryFilter}
                  onChange={setInventoryFilter}
                  options={InventoryOptions}
                  placeholder={t('Inventory')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
            </div>

            {/* ✅ نوع الحركة */}
            <div className='col-lg-4'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-layer-group'></i>
                </span>
                <Select
                  value={transTypeFilter}
                  // onChange={setTransTypeFilter}

                  onChange={opt => {
                    setTransTypeFilter(opt);
                  }}
                  options={OptionsTransactionTypes}
                  isLoading={loadingTransTypes}
                  placeholder={t('TransType')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
            </div>

            {/* ✅ posted */}
            {/* <div className='col-lg-3'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-check-circle'></i>
                </span>
                <Select
                  value={postedFilter}
                  onChange={setPostedFilter}
                  options={postedOptions}
                  placeholder={t('PostingStatus')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
            </div> */}

            {/* ✅ Date From-To */}
            <div className='col-lg-6'>
              <div className='input-group'>
                <span className='input-group-text'>
                  <i className='fas fa-calendar-alt text-muted'></i>
                </span>
                <input
                  type='date'
                  className='form-control border-start-0'
                  value={dateFrom}
                  onChange={e => setDateFrom(e.target.value)}
                />
                <span className='input-group-text'>-</span>
                <input type='date' className='form-control' value={dateTo} onChange={e => setDateTo(e.target.value)} />
              </div>
            </div>

            {/* ✅ Buttons */}
            <div className='col-lg-6 text-end'>
              <button
                className='btn btn-outline-secondary me-2'
                type='button'
                onClick={clearFilters}
                title={t('ClearFilters')}
                disabled={activeFiltersCount === 0}
              >
                <i className='fas fa-times fa-fw'></i>
              </button>

              <button
                className='btn btn-theme me-2'
                type='button'
                onClick={applyFilters}
                title={t('ApplyFilters')}
                disabled={
                  !branchFilter &&
                  !inventoryFilter &&
                  !transTypeFilter &&
                  !postedFilter &&
                  !referenceTypeFilter &&
                  !dateFrom &&
                  !dateTo
                }
              >
                <i className='fas fa-filter fa-fw'></i>
              </button>

              <button className='btn btn-outline-theme' onClick={() => setShowFilters(true)} title={t('SearchFilters')}>
                <i className='fas fa-sliders-h fa-fw'></i>
              </button>
            </div>
          </div>
        </CardHeader>

        <Loading loading={loading} error={error}>
          <div className='table-responsive'>
            <table className='table table-hover mb-0'>
              {/* ✅ نفس فكرة “أعمدة مركّبة” مثل مثال السندات */}
              <thead className='bg-theme bg-opacity-25 fw-bold'>
                <tr>
                  <th className='small'>
                    {t('Number')} / {t('Date')}
                  </th>

                  <th className='small'>
                    {t('ReferenceNumber')} / {t('ReferenceType')}
                  </th>
                  <th className='small'>
                    {t('OperationUnit')} / {t('Inventory')}
                  </th>
                  <th className='small text-center'>{t('PostingStatus')}</th>
                  <th className='small text-center'>{t('Actions')}</th>
                </tr>
              </thead>

              <tbody>
                {data.length > 0 ? (
                  data.map((item: any) => {
                    const transTypeName =
                      i18n.language === 'en'
                        ? item.transactionTypeName
                        : item.transactionTypeName2 || item.transactionTypeName;

                    const branchName = i18n.language === 'en' ? item.branchName : item.branchName2 || item.branchName;
                    const invName = i18n.language === 'en' ? item.inventory : item.inventory2 || item.inventory;

                    return (
                      <tr key={item.id}>
                        {/* رقم الحركة + التاريخ */}
                        <td className='align-middle'>
                          <div className='d-flex flex-column'>
                            <div className='fw-bold text-theme' style={{ letterSpacing: '0.05em' }}>
                              {item.code}
                            </div>
                            <small className='text-muted'>
                              <i className='fas fa-calendar-alt me-1'></i>
                              {safeDate(item.transactionDate)}
                            </small>
                          </div>
                        </td>

                        {/* المرجع + نوع المرجع */}
                        <td className='align-middle'>
                          <div className='d-flex flex-column gap-1'>
                            <div>
                              {item.referenceCode ? (
                                <span className='badge bg-secondary bg-opacity-35 text-body' title={item.referenceCode}>
                                  <i className='fas fa-hashtag me-1'></i>
                                  {item.referenceCode}
                                </span>
                              ) : (
                                <span className='text-muted'>—</span>
                              )}
                            </div>
                            <div>{getTransactionBadge(transTypeName)}</div>
                          </div>
                        </td>

                        {/* الفرع + المخزن */}
                        <td className='align-middle'>
                          <div className='d-flex flex-column'>
                            <div className='fw-bold'>
                              {/* <i className='fas fa-code-branch me-1 text-muted'></i> */}
                              <i className='fas fa-building me-1'></i>
                              {branchName || '—'}
                            </div>
                            <small className='text-muted mt-1'>
                              <i className='fas fa-warehouse me-1'></i>
                              {invName || '—'}
                            </small>
                          </div>
                        </td>

                        {/* الترحيل */}
                        <td className='align-middle text-center'>{getPostedFlagBadge(item.postedFlag || false)}</td>

                        {/* الإجراءات */}
                        <td className='align-middle text-end'>
                          <div className='d-flex justify-content-end gap-2'>
                            {HasPermission('INVViewInvReceiveDetails') && (
                              <button
                                type='button'
                                className='btn btn-sm btn-outline-theme'
                                title={t('ViewDetails')}
                                onClick={() => Navigate(`${item.id}/UpdateInvReceive`)}
                              >
                                <i className='bi bi-info-circle fa-lg me-1'></i>
                                {t('ViewDetails')}
                              </button>
                            )}

                            <button
                              type='button'
                              className='btn btn-sm btn-outline-secondary'
                              title={t('Print')}
                              onClick={() => {
                                setTransItem(item);
                                setShowPrint(true);
                              }}
                            >
                              <i className='fas fa-print fa-fw'></i>
                            </button>

                            {HasPermission('INVEditInvReceive') && (
                              <button type='button' className='btn btn-sm btn-outline-danger' title={t('Delete')}>
                                <i className='far fa-trash-alt fa-fw'></i>
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={6} className='text-center py-5 text-muted'>
                      <div className='py-4'>
                        <i className='fa fa-inbox fa-3x mb-3 opacity-50'></i>
                        <h5 className='mb-2'>{activeFiltersCount > 0 ? t('NoSearchResults') : t('NoData')}</h5>
                        <p className='text-muted small'>
                          {activeFiltersCount > 0
                            ? 'جرّب تقليل الفلاتر أو تغيير التاريخ'
                            : 'لا توجد حركات استلام/إضافة مسجلة'}
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Loading>

        <CardFooter>
          <div className='text-theme'>
            <DynamicPagination tableKey={TABLE_KEY} maxVisiblePages={3} showItemsPerPage={true} />
          </div>
        </CardFooter>
      </Card>

      <DynamicFilter tableKey={TABLE_KEY} fields={fields} show={showFilters} onClose={() => setShowFilters(false)} />

      {/* ✅ Print Modal مثل القديم */}
      <NeatixModal show={showPrint} setShow={setShowPrint} size='sm' showHeader={false} centered bodyClassName='p-0'>
        <Card>
          <div className='p-3'>
            {transItem && (
              <>
                <div className='text-theme text-center bg-theme bg-opacity-10 fs-4 fw-bold mb-3'>{transItem?.code}</div>
                <ListPrint ReferenceId={transItem.id} PrintTemplateTypeId='4F0C8A75-34C7-4701-A35F-D9D92C4FFFC5' />
              </>
            )}

            <button
              type='button'
              className='btn btn-lg btn-default rounded-1 w-100 mt-3'
              onClick={() => setShowPrint(false)}
            >
              <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
            </button>
          </div>
        </Card>
      </NeatixModal>
    </>
  );
};

export default Index;
